import React, { useState } from "react";

import { useIntl } from "react-intl";

import useDecodedParams from "Hooks/useDecodedParams";

import * as S from "../Details.styles";

import { showViewAllEnvironments } from "./utils";

const MultipleEnvironments = ({
  isBlackfireProjectVariable,
  blackfireEnviromentVariables,
  projectVariables
}) => {
  const intl = useIntl();

  const [expandedEnvironmentLinks, setExpandedEnvironmentLinks] =
    useState(false);

  const {
    organizationId,
    projectId
  }: { organizationId: string; projectId: string } = useDecodedParams();

  const minimumEnvironmentsToShowButton = 3;
  const maximumEnvironmentsToShow = 2;

  const showViewAll = showViewAllEnvironments(
    blackfireEnviromentVariables,
    projectVariables,
    minimumEnvironmentsToShowButton
  );

  const blackfireEnviromentVariablesSliced =
    blackfireEnviromentVariables?.slice(
      0,
      !expandedEnvironmentLinks ? maximumEnvironmentsToShow : undefined
    );

  const projectVariablesUrl = `/${organizationId}/${projectId}/-/settings/variables`;

  const environmentUrl = envId => {
    return `/${organizationId}/${projectId}/${envId}/settings`;
  };

  return (
    <>
      <S.ContainerMultiple>
        {intl.formatMessage({
          id: "integration.blackfire.warning.multiple",
          defaultMessage: " View or manage these variables in: "
        })}
        <ul>
          {isBlackfireProjectVariable && (
            <li>
              <S.Link href={projectVariablesUrl}>
                {intl.formatMessage({
                  id: "integration.blackfire.multiple.project.environments.url",
                  defaultMessage: " Learn more."
                })}
              </S.Link>
            </li>
          )}

          {blackfireEnviromentVariables?.length > 0 &&
            blackfireEnviromentVariablesSliced?.map(variable => (
              <li key={variable}>
                <S.Link href={environmentUrl(Object.keys(variable)[0])}>
                  {Object.keys(variable)[0]}
                </S.Link>
              </li>
            ))}
        </ul>
        {!expandedEnvironmentLinks && showViewAll && (
          <S.LinkPointer onClick={() => setExpandedEnvironmentLinks(true)}>
            {intl.formatMessage({
              id: "view_all",
              defaultMessage: "View all"
            })}
          </S.LinkPointer>
        )}
      </S.ContainerMultiple>
    </>
  );
};

export default MultipleEnvironments;
